import { render, staticRenderFns } from "./CompareBarChart.vue?vue&type=template&id=0dc4fb33&"
import script from "./CompareBarChart.vue?vue&type=script&lang=js&"
export * from "./CompareBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports